<template>
  <el-dialog
    title="设置指定机型"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="1300px"
    style="z-index: 3000;position: fixed;"
    @close="btnStoreClose"
  >
    <GlobalForm
      v-if="showForm"
      :form-item-list="formItemList"
      :inline="true"
      round
      confirmBtnName="查询"
      @handleConfirm="search"
    />
    <div style="display: flex; justify-content: space-between">
      <el-card>
        <div style="font-weight: bold; height: 40px">添加机型</div>
        <GlobalTable
          ref="leftTable"
          v-loading="leftLoading"
          :columns="tableColumns"
          :data="leftList"
          :currentPage="leftResult.current"
          :total="leftResult.total"
          :pageSize="pageSize"
          :max-height="500"
          isSelection
          @handleSelectionChange="(v) => (leftSelectList = v)"
          @handleCurrentChange="getLeftData"
          ></GlobalTable>
      </el-card>
      <div class="arrows-box"></div>
      <el-card>
        <div style="font-weight: bold; height: 40px">
          已添加机型（{{ idList.length }}个）
        </div>
        <GlobalTable
          ref="rightTable"
          v-loading="rightLoading"
          :columns="tableColumns"
          :data="rightList"
          :currentPage="rightResult.current"
          :total="rightResult.total"
          :pageSize="pageSize"
          :max-height="500"
          isSelection
          @handleSelectionChange="(v) => (rightSelectList = v)"
          @handleCurrentChange="getRightData"
          ></GlobalTable>
      </el-card>
    </div>
    <div slot="footer">
    </div>
  </el-dialog>
</template>

<script>
import _api from "@/utils/request";
export default {
  name: "MachineListDia",
  props: {
    machineIds: {
      type: Array,
      default: () => [],
    },
    // 左请求列表忽略的id（已选）
    omitIds: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      dialogVisible: false,
      // 搜索条件相关
      showForm: false,
      filterData: {},
      formItemList: [
        {
          labelName: "选择分类",
          key: "machineTypeId",
          type: "selectFilterable",
          placeholder: "请选择分类",
          clear: true,
          option: []
        },
        {
          labelName: "选择品牌",
          key: "brandId",
          type: "selectFilterable",
          placeholder: "请选择品牌",
          clear: true,
          option: []
        },
        {
          labelName: "机型名称",
          key: "name",
          type: "input",
          placeholder: "请输入机型名称",
        },
      ],
      // Table数据相关，list展示的数据，SelectList选中的列表，Result接口返回
      rightList: [],
      leftList: [],

      leftSelectList: [],
      rightSelectList: [],

      leftLoading: false,
      rightLoading: false,

      leftResult: {
        total: 0,
        current: 1
      },
      rightResult: {},

      pageSize: 10,
      leftTotal: 0,
      rightTotal: 0,
      tableColumns: [
        { label: '分类', prop: "typeName" },
        { label: '品牌', prop: "brandName" },
        { label: '机型名称', prop: "name" },
        { label: '机型来源', prop: "channel" },
      ],

      // 选中的id列表
      idList: [],
    };
  },
  created() {
    this.getClassList()
    this.getResidentList()
  },
  methods: {
    open() {
      // 清空筛选
      this.filterData = {}
      this.showForm = true
      this.idList = JSON.parse(JSON.stringify(this.machineIds)) || []
      this.dialogVisible = true;
      this.getData()
    },
    getData() {
      this.getLeftData()
      this.getRightData()
    },
    getLeftData(pageNum = 1) {
      this.leftLoading = true
      _api.listByTypeBrandPage({ 
        ...this.filterData,
        type: '01',
        assignMachineModelIds: [...this.omitIds, ...this.idList],
        pageNum,
        pageSize: this.pageSize
      }).then(res => {
        this.leftResult = res.data
        this.leftList = res.data.records || []
      }).finally(() => {
        this.leftLoading = false
      })
    },
    getRightData(pageNum = 1) {
      this.rightLoading = true
      _api.listByTypeBrandPage({
        ...this.filterData,
        type: '02',
        assignMachineModelIds: this.idList,
        pageNum,
        pageSize: this.pageSize
      }).then(res => {
        this.rightResult = res.data
        this.rightList = res.data.records || []
      }).finally(() => {
        this.rightLoading = false
      })
    },
    // 获取分类集合
    getClassList() {
      _api.selectList().then(res => {
        const list = res.data.map(item => ({
          value: item.id,
          label: item.name
        }))
        this.formItemList[0].option = list
      })
    },
    // 获取旧机品牌列表
    getResidentList() {
      _api.ResidentList().then(res => {
        const list = res.data.map(item => ({
          value: item.id,
          label: item.name
        }))
        this.formItemList[1].option = list
      })
    },
    search(v) {
      this.filterData = v
      this.getData()
    },
    confirm() {
      this.$emit(
        "confirm",
        JSON.parse(JSON.stringify(this.idList))
      );
      this.btnStoreClose();
    },
    btnStoreClose() {
      this.dialogVisible = false;
      this.showForm = false
    },
    move(type) {
      // 数据移动
      const selectList =
        type === "left" ? this.rightSelectList : this.leftSelectList;
      const selectIds = selectList.map((item) => item.id);
      if (type === "right") {
        this.rightList.push(...selectList);
        this.leftList = this.leftList.filter(
          (item) => !selectIds.includes(item.id)
        );
        this.idList = [...this.idList, ...selectIds]
      } else {
        this.leftList.push(...selectList);
        this.rightList = this.rightList.filter(
          (item) => !selectIds.includes(item.id)
        );
        this.idList = this.idList.filter((id) => !selectIds.includes(id))
      }
      // this.$emit('input', this.rightList.map(item => item.id))
    },
  },
};
</script>

<style lang="scss" scoped>
.arrows-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  .arrow-btn {
    width: 40px;
    height: 40px;
    box-sizing: border-box;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: 2px 6px 6px 0px rgba(102, 102, 102, 0.16);
    &[disabled] {
      cursor: not-allowed;
    }
  }
}
</style>